<template>
  <select v-model="user.state" :required="required" autocomplete="state" @blur="$emit('blur', $event.target.value)">
    <option value="">{{ $t('labels.state') }}</option>
    <option v-for="state in states" :value="state.abbreviation" :key="state.abbreviation">
      {{ state.name }}
    </option>
  </select>
</template>
<script>
import states from '@/config/us-states.json'

export default {
  data() {
    return {
      states,
    }
  },
  props: {
    user: {},
    required: {
      type: Boolean,
      default: true,
    }
  }
}
</script>
